import Component from '../abstracts/Component';
import vex from 'vex-js';
import TrackingComponent from '../components/TrackingComponent';
import Cookies from 'js-cookie';

export default class AddToCartComponent extends Component {

  get COMPONENTNAME() {
    return 'AddToCartComponent';
  }

  get SELECTORS() {
    return {
      addToCartBtn: '[data-js-add-to-cart]',
      queryId: '[data-algolia-query-id]',
      authenticatedUserToken: '[data-authenticated-user-token]',
      searchIndex: '[data-search-index]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.addToCartBtn = this.$component.querySelector(this.SELECTORS.addToCartBtn);
    this.TrackingComponent = new TrackingComponent();
  }

  // add to cart server calls //
  addToCart(sizeCode, addToCartBtn) {
    addToCartBtn.classList.add("--loading");
    const queryId = document.querySelector(this.SELECTORS.queryId)?.dataset?.algoliaQueryId;
    let url = addToCartBtn.dataset.href + '?code=' + sizeCode;

    // SEND EXTRA PARAMETERS IF ALGOLIA IS ENABLED
    if(queryId && queryId != ''){
      let authenticatedUserToken = document.querySelector(this.SELECTORS.authenticatedUserToken)?.dataset?.authenticatedUserToken;
      let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;
      let indexName = document.querySelector(this.SELECTORS.searchIndex)?.dataset?.searchIndex;
      url = addToCartBtn.dataset.href + '?code=' + sizeCode + '&queryId=' + queryId + '&authenticatedUserToken=' + authenticatedUserToken + '&userToken=' + userToken + '&indexName=' + indexName;
    }

    fetch(url, {method: 'POST' })
    .then(res => {
      if (res.ok) {
        addToCartBtn.classList.remove("--loading");
        res.text().then(text => {
          if (text == 650) {
            //show exceeded cart quantity modal
            const remoteHref = addToCartBtn.dataset.exceededCartQty;
            const url = remoteHref + sizeCode;
            this.openModal(url);
          } else if (text == 651) {
            //show low stock modal
            const remoteHref = addToCartBtn.dataset.lowstockCartQty;
            const url = remoteHref + sizeCode;
            this.openModal(url);
          } else {
            // if no error occurs then emit event
            this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtocart, {productCode: sizeCode, btn:addToCartBtn });
          }
        });
        return true;
      } else {
        if (res.status == 510) {
          //show product unavailable modal
          const remoteHref = addToCartBtn.dataset.remoteUnavailable;
          const url = remoteHref + sizeCode;
          const ctx = this;
          fetch(url)
            .then(response => response.text())
            .then(content => {
              vex.open({
                unsafeContent: content,
                closeClassName: 'icon-close',
                showCloseButton: true,
                afterOpen: function () {
                  this.closeEl.classList.remove('vex-close');
                  ctx.unavailableModalInit(this);
                }
              });
            })
            .catch(error => console.error(error));
        }
        addToCartBtn.classList.remove("--loading");
        return false;
      }
    })
    .catch(error => console.error(error));
  }

  // modals //
  openModal(url) {
    fetch(url)
    .then(response => response.text())
    .then(content => {
      vex.open({
        unsafeContent: content,
        closeClassName: 'icon-close',
        showCloseButton: true,
        afterOpen: function () {
          this.closeEl.classList.remove('vex-close');
        }
      });
    })
    .catch(error => console.error(error));
  }

  unavailableModalInit(modal) {
    const notifyMeBtn = modal.contentEl.querySelector("[data-js-notifyme-btn]");
    const notifyMeForm = modal.contentEl.querySelector("[data-js-notifyForm]");
    const backBtn = modal.contentEl.querySelector('#backBtn');
    const confirmSection = modal.contentEl.querySelector('[data-js-confirm]');
    const confirmText = modal.contentEl.querySelector('[data-js-response]');
    const errorMsg = modal.contentEl.querySelector('[data-js-error]');
    const inputForm = modal.contentEl.querySelector('input[name="email"]');
    const submitBtn = modal.contentEl.querySelector('button[type="submit"]');

    if (submitBtn) {
      if (inputForm.value.length > 0) {
        submitBtn.disabled = false;
      }
      inputForm.addEventListener("input", () => {
        submitBtn.disabled = false;
      });
    }
    backBtn.addEventListener("click", event => {
      modal.close();
    });
    notifyMeBtn.addEventListener("click", event => {
      event.preventDefault();
      backBtn.classList.remove("--primary");
      backBtn.classList.add("--secondary");
      notifyMeForm.classList.remove("--hidden");
    });
    notifyMeForm.addEventListener("submit", event => {
      event.preventDefault();
      event.stopPropagation();
      const url = notifyMeForm.getAttribute("action");
      const form = new URLSearchParams(new FormData(notifyMeForm));
      fetch(url,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: form
        }
      )
        .then(response => {
          if (response.ok) {
            response.text().then( text => {
              backBtn.classList.add("--primary");
              backBtn.classList.remove("--secondary");
              notifyMeForm.classList.add("--hidden");
              notifyMeBtn.classList.add("--hidden");
              confirmSection.classList.remove("--hidden");
              confirmText.innerHTML = text;
            })
          } else {
            notifyMeForm.querySelector('.custom-input').classList.add("error");
            errorMsg.classList.remove("--hidden");
            submitBtn.disabled = false;
          }
        })
        .catch(error => console.warn(error));
    });
  }

  bindEvents() {
    // global
    // click on addtocart button
    if(this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', (event) => {
        event.preventDefault();
        // get size code
        let sizeSelected = null;
        // product is uniqueSize
        if (this.addToCartBtn.dataset.uniqueSize === 'true') {
          this.addToCart(this.addToCartBtn.dataset.productCode, this.addToCartBtn);
          this.TrackingComponent.actions.addToCart(this.addToCartBtn.dataset.productCode);
        }
        // product has sizes
        if (this.addToCartBtn.dataset.uniqueSize === 'false') {
          // handle added to cart
          const sizeSelected = this.addToCartBtn.dataset.selectedProduct;
          if (sizeSelected) {
            this.addToCart(sizeSelected, this.addToCartBtn);
            this.TrackingComponent.actions.addToCart(sizeSelected);
          } else {
            this.$emit(this.$customEvents.PRODUCT_EVENTS.sizerequired, this.addToCartBtn);
          }
        }
      });
    }

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      if(payload.productCode !== this.addToCartBtn.dataset.productCode && payload.baseProductCode !== this.addToCartBtn.dataset.baseProduct) {
        this.addToCartBtn.dataset.selectedProduct = payload.productCode;
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechangedwish, ({event, payload}) => {
      if(this.$component.dataset.index == payload.itemIndex) {
        this.addToCartBtn.dataset.selectedProduct = payload.productCode;
      }
    });

    // handle add to cart inner msg on add to cart
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      if(payload.btn == this.addToCartBtn) {
        this.addToCartBtn.querySelector(".custom-button__message").innerHTML = this.addToCartBtn.dataset.addedMsg;
        setTimeout(() => {
          this.addToCartBtn.querySelector(".custom-button__message").innerHTML = this.addToCartBtn.dataset.standardMsg;
        }, 3000);
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      if(payload.productCode == this.addToCartBtn.dataset.productCode) {
        this.addToCartBtn?.classList.add("--hidden");
      }
    });
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      if(payload.productCode == this.addToCartBtn.dataset.productCode) {
        this.addToCartBtn?.classList.remove("--hidden");
      }
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
